import * as React from "react";
import type { SVGProps } from "react";
const SvgXCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.707 9.707a1 1 0 0 0-1.414-1.414zm-7.414 4.586a1 1 0 1 0 1.414 1.414zm1.414-6a1 1 0 0 0-1.414 1.414zm4.586 7.414a1 1 0 0 0 1.414-1.414zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm2.293 5.293-6 6 1.414 1.414 6-6zm-6 1.414 6 6 1.414-1.414-6-6z"
    />
  </svg>
);
export default SvgXCircle;
